const dashboardDataSelector = state => {
  const { invoicesByStatus, invoicesByPaymentMode, invoicesByDate } = state.dashboardStore;

  return { invoicesByStatus, invoicesByPaymentMode, invoicesByDate };
};

const dateRangeSelector = state => {
  const { dateRange } = state.dashboardStore;

  return dateRange;
};

const totalSelector = state => {
  const { totalInvoices, totalPayments } = state.dashboardStore;

  return { totalInvoices, totalPayments };
};

const typesSelector = state => state.dashboardStore.typeFilters;

const selectedTypeSelector = state => {
  const selected = state.dashboardStore.typeFilters.find(t => t.isActive);
  return selected?.key === "ALL" ? null : selected?.key;
};

export { dashboardDataSelector, totalSelector, dateRangeSelector, typesSelector, selectedTypeSelector };
